import { ThemeConfig } from "../shared/theme";

import * as theme from './blue';
import * as emptyTheme from './empty';

let ThemeComponents: ThemeConfig = {
    'default': {
        component: theme,
        css: ['/static/themes/blue/css/extension.css', '/static/themes/blue/css/common.css', '/static/themes/blue/css/blue.css'],
        layouts: {
            'default': theme.DefaultLayout,
            'empty': theme.EmptyLayout
        }
    },
    'empty': {
        component: emptyTheme,
        css: ['/static/themes/blue/css/extension.css', '/static/themes/blue/css/common.css', '/static/themes/blue/css/blue.css', '/static/themes/empty/css/empty.css'],
        layouts: {
            'empty': theme.EmptyLayout
        }
    }
};

export default ThemeComponents;